// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Image, Link, handleEnterKey } from '@iheartjane/reefer';

type CarouselItemProps = {
  activeIndex: number;
  fallbackSrc?: string;
  imageAlt: string;
  imageSrc: string;
  index?: number;
  onClick: () => void;
  srcSet?: string;
  url?: string | null;
  variant: string;
};

const InnerCarouselItem = styled.div(() => ({
  height: '100%',
  minWidth: '100%',
  position: 'relative' as const,
  display: 'flex',
  alignItems: 'center',
  cursor: 'default',
}));

export const CarouselItem = ({
  activeIndex,
  fallbackSrc,
  imageAlt,
  imageSrc,
  index = 0,
  onClick,
  srcSet,
  url,
}: CarouselItemProps) => {
  const imageObjectFit = 'cover';
  const imageBorderRadius = 'none';
  const isActive = activeIndex === index;
  const isPriority = isActive || Math.abs(activeIndex - index) <= 1;

  return (
    <InnerCarouselItem
      data-testid="carousel-item"
      draggable={false}
      onClick={onClick}
      onKeyUp={(event) => handleEnterKey(event, onClick)}
    >
      {url ? (
        <Link
          href={url}
          variant="minimal"
          style={{
            height: '100%',
            width: '100%',
          }}
        >
          <Image
            src={imageSrc}
            srcSet={srcSet}
            altText={imageAlt}
            objectFit={imageObjectFit}
            height="100%"
            width="100%"
            borderRadius={imageBorderRadius}
            fallbackSrc={fallbackSrc}
            loading={isPriority ? 'eager' : 'lazy'}
          />
        </Link>
      ) : (
        <Image
          src={imageSrc}
          srcSet={srcSet}
          altText={imageAlt}
          objectFit={imageObjectFit}
          height="100%"
          borderRadius={imageBorderRadius}
          fallbackSrc={fallbackSrc}
          loading={isPriority ? 'eager' : 'lazy'}
        />
      )}
    </InnerCarouselItem>
  );
};
